import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoviesinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 9.125L16 6v8l-4-2.875V13a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.125zM8.5 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM3 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgMoviesinline;
